import { NgModule } from '@angular/core';
import { GenericTablePaginationModule } from '@angular-generic-table/core';
import { GenericTableCoreModule } from '@angular-generic-table/core';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';

@NgModule({
    declarations: [GenericTableComponent],
    imports: [GenericTableCoreModule, GenericTablePaginationModule],
    exports: [GenericTableComponent, GenericTableCoreModule, GenericTablePaginationModule]
})
export class TableModule {}
